// extracted by mini-css-extract-plugin
export default {"wrapper":"RemoveModal_wrapper__rPkEc","confirm-button":"RemoveModal_confirm-button__28Gtz"};